module.exports = __webpack_public_path__ + "static/media/YF94_3.3e629665.jpg";